import React from 'react';
import '../../CSS/TimetableModel.css';
import {Card} from '@material-ui/core';
import {motion} from 'framer-motion';
import {getConvertedTime} from '../../Functions.js';

function Model(props) {
    var index = props.index;
    var attendance = props.item;
    
    var start = getConvertedTime(attendance.start);
    var end = getConvertedTime(attendance.end);
    var title = attendance.title;
    var faculty = attendance.FacultyName;
    var courseCode = attendance.CourseCode;
    var roomNo = attendance.RoomNo;

    const pageVariants = {
        initial :{
            opacity: 0,
            scale: 0.5,
            y:"110%"
        },
        in:{
            opacity: 1,
            scale:1,
            y:0
        },
      };
      
      const pageTransition = {
        type: "tween",
        ease: "anticipate",
        duration: index*0.15
      };
      
    
    return(
        <div className="MainModel"
        initial="initial"
        animate="in"
        variants={pageVariants}
        transition={pageTransition}>
            <Card
                raised
                className="Model"
                style={{
                    backgroundColor:"#ffffff",
                    borderRadius:"20px",
                }}>
                    <div className="Overall">
                        <div className="Time">
                            <div className="TimeText">
                                {start}
                            </div>
                            <div className="TimeLine">
                                -
                            </div>
                            <div className="TimeText">
                                {end}
                            </div>
                        </div>
                        <div className="Details">
                            <div className="Title">
                                {title}
                            </div>
                            <div className="Faculty">
                                    {faculty}
                            </div>
                            

                            <div className="CCodeAndRoomNo">
                                <div className="CCode">
                                    {courseCode}
                                </div>
                                <div className="RoomNo">
                                    {roomNo}
                                </div>
                            </div>
 
                        </div>
                    </div>
            </Card>
        </div>
    );
}

export default Model;